module.exports = __webpack_public_path__ + "img/rg-back.3af11e04.png";